import {
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBIcon
} from "mdbreact";
import anaImage from "Styles/img/home/ana.jpg";
import jelenaImage from "Styles/img/home/jelena.jpg";
import vesnaImage from "Styles/img/home/vesna.jpg";
import locale from "locale";

const TestimonialsPage = () => {
  return (
    <section className="text-center moz-p-home__section">
      <h2 className="h1 my-5 font-weight-bold heading-secondary">
        {locale.TESTIMONIALS.QUESTION}
      </h2>
      <p className="paragraph--lead grey-text mb-5">
        {locale.TESTIMONIALS.ANSWER}
      </p>
      <MDBRow>
        <MDBCol lg="4" md="12" className="mb-lg-0 mb-4 px-5">
          <MDBCard className="moz-c-card" style={{ position: "relative" }}>
            <div className="moz-c-testimonial">
              <MDBCardImage
                className="img-fluid rounded-circle mx-auto mt-5 mb-2 moz-c-testimonial__image"
                src={anaImage}
                waves
              />
            </div>
            <MDBCardBody>
              <h4 className="font-weight-bold mb-4 heading-tertiary">
                {locale.TESTIMONIALS.PERSON_1_NAME}
              </h4>
              <hr />
              <p className="mt-4 paragraph">
                <sup>
                  <MDBIcon icon="quote-left" className="pr-2" />
                </sup>
                {locale.TESTIMONIALS.PERSON_1_QUOTE}
                <sub>
                  {" "}
                  <MDBIcon icon="quote-right" className="pr-2" />
                </sub>
              </p>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        <MDBCol lg="4" md="12" className="mb-lg-0 mb-4 px-5">
          <MDBCard className="moz-c-card" style={{ position: "relative" }}>
            <div className="moz-c-testimonial moz-c-testimonial--1">
              <MDBCardImage
                className="img-fluid rounded-circle mx-auto mt-5 mb-2 moz-c-testimonial__image"
                src={jelenaImage}
                waves
              />
            </div>
            <MDBCardBody>
              <h4 className="font-weight-bold mb-4 heading-tertiary">
                {locale.TESTIMONIALS.PERSON_2_NAME}
              </h4>
              <hr />
              <p className="mt-4 paragraph">
                <sup>
                  <MDBIcon icon="quote-left" className="pr-2" />
                </sup>
                {locale.TESTIMONIALS.PERSON_2_QUOTE}
                <sub>
                  {" "}
                  <MDBIcon icon="quote-right" className="pr-2" />
                </sub>
              </p>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
        <MDBCol lg="4" md="12" className="mb-lg-0 mb-4 px-5">
          <MDBCard className="moz-c-card" style={{ position: "relative" }}>
            <div className="moz-c-testimonial moz-c-testimonial--2">
              <MDBCardImage
                className="img-fluid rounded-circle mx-auto mt-5 mb-2 moz-c-testimonial__image"
                src={vesnaImage}
                waves
              />
            </div>
            <MDBCardBody>
              <h4 className="font-weight-bold mb-4 heading-tertiary">
                {locale.TESTIMONIALS.PERSON_3_NAME}
              </h4>
              <hr />
              <p className="mt-4 paragraph">
                <sup>
                  <MDBIcon icon="quote-left" className="pr-2" />
                </sup>
                {locale.TESTIMONIALS.PERSON_3_QUOTE}
                <sub>
                  {" "}
                  <MDBIcon icon="quote-right" className="pr-2" />
                </sub>
              </p>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </section>
  );
};

export default TestimonialsPage;
